import axios from 'axios'
import { voiceUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 语音左侧群组列表查询
export function findWalkieList(params) {
  const url = voiceUrl + '/chat/find'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯-语音通话', '语音左侧群组列表查询', res)
    }
    return Promise.resolve(res.data)
  })
}

// 新增对话组
export function saveWalkieGroup(params) {
  const url = voiceUrl + '/chat/save'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯-语音通话', '新增对话组', res)
    }
    return Promise.resolve(res.data)
  })
}

// 编辑对话组
export function editWalkieGroup(params) {
  const url = voiceUrl + '/chat/update'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯-语音通话', '编辑对话组', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除对话组
export function deleteWalkieGroup(params) {
  const url = voiceUrl + '/chat/' + params
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯-语音通话', '删除对话组', res)
    }
    return Promise.resolve(res.data)
  })
}
// 获取群组人员列表树
export function getUserTree(params) {
  const url = voiceUrl + '/chat/find/roomId'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯-语音通话', '获取群组人员列表树', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取群组人员列表树
export function getUserTreeWalkie(params) {
  const url = voiceUrl + '/chat/find/roomId'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯-语音通话', '获取群组人员列表树', res)
    }
    return Promise.resolve(res.data)
  })
}
